<template>
    <tr class="border-0">
        <td class="text-center">
            <i :class="['far', 'shared-file-type-icon', getFileIcon(asset.mimeType)]"></i>
        </td>
        <td>
            <a :href="asset.url" target="_blank">{{ asset.fileName }}</a>
        </td>
        <td>{{ formatDate(asset.modifiedDate, "MMM DD") }}</td>
        <td class="me-3 d-none d-md-table-cell">{{ asset.uploaderFirstName }} {{ asset.uploaderLastName }}</td>
    </tr>
</template>

<style src="./ConversationSharedFileRow.scss"></style>
<script lang="ts" src="./ConversationSharedFileRow.ts"></script>
